module.exports = __webpack_public_path__ + "static/media/tut-7.7d08e721.png";